import * as React from "react";
import { Source, Layer } from "react-map-gl/mapbox";

const CLUSTER_PAINT = {
  "circle-color": [
    "step",
    ["get", "point_count"],
    "#4caf50", // < 10 devices
    10,
    "#ff9800", // 10-50 devices
    50,
    "#f44336", // 50+ devices
  ],
  "circle-radius": [
    "step",
    ["get", "point_count"],
    20, // < 10 devices
    10,
    25, // 10-50 devices
    50,
    30, // 50+ devices
  ],
  "circle-stroke-width": 2,
  "circle-stroke-color": "#ffffff",
};

const CLUSTER_COUNT_LAYOUT = {
  "text-field": "{point_count_abbreviated}",
  "text-font": ["DIN Offc Pro Medium", "Arial Unicode MS Bold"],
  "text-size": 12,
};

const UNCLUSTERED_PAINT = {
  "circle-color": [
    "case",
    ["get", "isOutdated"],
    "#f44336", // Red for outdated
    "#4caf50", // Green for active
  ],
  "circle-radius": 8,
  "circle-stroke-width": 2,
  "circle-stroke-color": "#ffffff",
};

/**
 * Clustered device markers for the devices map. Renders the clustered GeoJSON
 * source plus cluster, cluster-count and unclustered-point layers. Used when
 * the device count exceeds the clustering threshold.
 *
 * @param {Object} props
 * @param {Object} props.data - Clustered devices GeoJSON FeatureCollection
 */
const DeviceClusterLayers = ({ data }) => (
  <>
    <Source
      id="devices-clustered"
      type="geojson"
      data={data}
      cluster={true}
      clusterMaxZoom={14}
      clusterRadius={50}
    />

    {/* Cluster circles */}
    <Layer
      id="clusters"
      type="circle"
      source="devices-clustered"
      filter={["has", "point_count"]}
      paint={CLUSTER_PAINT}
    />

    {/* Cluster count labels */}
    <Layer
      id="cluster-count"
      type="symbol"
      source="devices-clustered"
      filter={["has", "point_count"]}
      layout={CLUSTER_COUNT_LAYOUT}
      paint={{ "text-color": "#ffffff" }}
    />

    {/* Unclustered individual points */}
    <Layer
      id="unclustered-point"
      type="circle"
      source="devices-clustered"
      filter={["!", ["has", "point_count"]]}
      paint={UNCLUSTERED_PAINT}
    />
  </>
);

export default React.memo(DeviceClusterLayers);
